import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import { filtersConfigStatusMap } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filtersConfig";
import { fetchSuppressionListsThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/suppressionListApi";

import { useScoringFiltersConfig } from "./useScoringFiltersConfig";

/**
 * Warms suppression lists and builds the leads + CRM filters catalog used by scoring boards.
 * Call once from a page container (e.g. Scoring Settings, Playbook Wizard), not from board
 * components, so modal open/close does not re-dispatch thunks or flicker readiness.
 */
export const useScoringFiltersBootstrap = () => {
    const dispatch = useDispatch();

    useMount(() => {
        void dispatch(fetchSuppressionListsThunk());
    });

    const { filtersList, status } = useScoringFiltersConfig();

    return {
        filtersList,
        isBootstrapping: status !== filtersConfigStatusMap.ready,
    };
};

/** @deprecated Use useScoringFiltersBootstrap */
export const useScoringPageBootstrap = useScoringFiltersBootstrap;
